import 'reflect-metadata';
import { Container } from 'inversify';
import { httpApi } from '../../common/infra/http';
import { BusinessPartnerHttpGateway } from './business-partner.http.gateway';
import { GetBusinessPartnerUseCase } from '../application/get-business-partner.use.case';

export const Registry = {
    AxiosAdapter: Symbol.for('AxiosAdapter'),
    BusinessPartnerGateway: Symbol.for('BusinessPartnerGateway'),
    GetBusinessPartnerUseCase: Symbol.for('GetBusinessPartnerUseCase')
};

export const container = new Container();

container.bind(Registry.AxiosAdapter).toConstantValue(httpApi);
container.bind(Registry.BusinessPartnerGateway).toDynamicValue((context) => {
    return new BusinessPartnerHttpGateway(context.container.get(Registry.AxiosAdapter));
});
container.bind(Registry.GetBusinessPartnerUseCase).toDynamicValue((context) => {
    return new GetBusinessPartnerUseCase(context.container.get(Registry.BusinessPartnerGateway));
});

const businessPartner = {
    getBusinessPartner: container.get<GetBusinessPartnerUseCase>(Registry.GetBusinessPartnerUseCase)
};
export default businessPartner;

